// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"1b4e6fc8","506":"a22264be","707":"490df2d7"}[chunkId] + ".js";
};